'use client';

import { FC, useState, useEffect, useRef } from 'react';
import { WoundLocationStep } from './libs/components/wound-location-step/wound-location-step';
import { WoundResultOfStep } from './libs/components/wound-result-of-step/wound-result-of-step';
import { DiabetDiagnosStep } from './libs/components/diabet-diagnos-step/diabet-diagnos-step';
import { WoundDurationStep } from './libs/components/wound-duration-step/wound-duration-step';
import { TreatmentWoundStep } from './libs/components/treatment-wound-step/treatment-wound-step';
import { useRouter } from 'next/navigation';
import { AppRoute } from 'apps/woundscantwait-com/src/libs/enums/app-route.enum';

const OpenWoundForm: FC = () => {
  const [step, setStep] = useState<number>(1);
  const formRef = useRef<HTMLDivElement>(null);

  const router = useRouter();

  useEffect(() => {
    if (step === 1) {
      return;
    }

    if (formRef.current) {
      window.scrollTo({
        top: formRef.current.offsetTop - 100,
        behavior: 'smooth',
      });
    }
  }, [step]);

  const renderStep = () => {
    switch (step) {
      case 1:
        return <WoundLocationStep onWoundLocationClick={() => setStep(2)} />;
      case 2:
        return <WoundResultOfStep onContinue={() => setStep(3)} />;
      case 3:
        return <DiabetDiagnosStep onContinue={() => setStep(4)} />;
      case 4:
        return <WoundDurationStep onContinue={() => setStep(5)} />;
      case 5:
        return (
          <TreatmentWoundStep
            onSubmit={() => router.push(AppRoute.HEALING_NAVIGATOR_INFORMATION)}
          />
        );
    }
  };

  return (
    <div
      ref={formRef}
      className="max-w-[1365px] w-full mt-[100px] bg-white rounded-t-[16px]"
    >
      <div className="w-full bg-gradient-to-r from-[#041C2C] to-[#002855] rounded-t-[16px] pt-2 pb-4">
        <div className="text-[24px] text-ogn-bright-yellow ml-5 lg:ml-[140px] font-bold">
          Question {step} of 5
        </div>
      </div>
      <div className="w-full border-b-[3px] border-b-ogn-bright-yellow px-5">
        {renderStep()}
      </div>
    </div>
  );
};

export { OpenWoundForm };
